// Course data: Python for Kids – 10-week curriculum (5 themes, 9 topics)
// Use Add New Course in Admin to create the course + one session

export const newCourseData = {
  title: '🐍 Python for Kids – From Setup to Capstone',
  description: `Primary Objective: To help students move from beginner coding knowledge to confidently building their own interactive Python projects using real developer tools.

What Students Will Achieve (20-hour program):
✅ Set up and use VS Code as a real development environment
✅ Write structured Python programs using functions
✅ Build interactive games using Turtle graphics
✅ Work with lists and basic data storage
✅ Create simple GUI applications
✅ Save and read data from files
✅ Complete and present a final capstone project`,
  courseType: 'programming',
  category: 'Python',
  level: 'beginner',
  topics: [
    {
      name: '⚙️ Week 1: VS Code Setup + First Program (Theme 1 – Developer Setup + Clean Code)',
      description: `Install Python • Install VS Code • Run files
Print, input • Basic debugging
Mini Build: Number guessing game`,
      hours: 2
    },
    {
      name: '⚙️ Week 2: Functions (Theme 1 – Developer Setup + Clean Code)',
      description: `Build: Mini calculator + quiz game
Outcome: They understand structure.`,
      hours: 2
    },
    {
      name: '🔵 Week 3: Turtle Basics (Theme 2 – Game Logic with Turtle)',
      description: `Movement • Loops • Colors
Build: Drawing app`,
      hours: 2
    },
    {
      name: '🔵 Week 4: Turtle Game (Theme 2 – Game Logic with Turtle)',
      description: `Build: Turtle race game OR Catch the ball
Outcome: They see animation → excitement spikes.`,
      hours: 2
    },
    {
      name: '🟡 Week 5: Lists & Dictionaries (Theme 3 – Data Handling)',
      description: `Build: Student score tracker`,
      hours: 2
    },
    {
      name: '🟡 Week 6: File Saving (Theme 3 – Data Handling)',
      description: `Upgrade tracker: Save data to file
Outcome: They understand data persistence.`,
      hours: 2
    },
    {
      name: '🟣 Week 7: Tkinter Basics (Theme 4 – Simple GUI App)',
      description: `Build: Color changing app`,
      hours: 2
    },
    {
      name: '🟣 Week 8: GUI Mini Project (Theme 4 – Simple GUI App)',
      description: `Build: Notes app or Password locker
Outcome: They feel like app developers.`,
      hours: 2
    },
    {
      name: '🔴 Week 9 & 10: Build Project + Demo Day (Theme 5 – Capstone)',
      description: `Week 9 – Build: Students choose Game • GUI app • Virtual pet
Week 10 – Present (no certificate provided)`,
      hours: 4
    }
  ]
};
